<!-- ==================== LISTA (patrón table-page) ====================
     Con una propuesta abierta la lista se DESTRUYE y se vuelve a armar al
     regresar: es corta (las pendientes y las últimas 50 resueltas) y así
     siempre se ve lo que hay en el servidor. -->
<div class="main-content table-page cpa" *ngIf="!abierta">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Cambios por aprobar</h1>
        <p>
          Lo que se guardó en las matrices de riesgos con el control de cambios encendido.
          Nada de esto está aplicado todavía: entra a la matriz cuando alguien con el perfil
          de edición lo acepta.
        </p>
      </div>
      <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact cpa-volver"
              (click)="volverAMatriz()">
        <span class="material-icons" aria-hidden="true">arrow_back</span>
        {{ idMatrizOrigen ? 'Volver a la matriz' : 'Gestión de Riesgos' }}
      </button>
    </section>

    <div class="cpa-aviso cpa-aviso--error" *ngIf="errorCarga" role="alert">
      <span class="material-icons" aria-hidden="true">error_outline</span>
      <span class="cpa-aviso-txt">{{ errorCarga }}</span>
      <button type="button" class="cpa-enlace" (click)="cargar()">Reintentar</button>
    </div>
    <div class="cpa-aviso cpa-aviso--info" *ngIf="!cargando && !errorCarga && !aprobacionActiva" role="note">
      <span class="material-icons" aria-hidden="true">info</span>
      <span class="cpa-aviso-txt">
        <b>El control de cambios está apagado:</b> lo que se guarda en la matriz se aplica directo.
        Aquí sólo aparece lo que quedó como propuesta antes de apagarlo.
      </span>
    </div>
    <!-- Sin el perfil el servidor sólo manda lo que usan los contadores:
         la bandeja no se pinta, sólo este aviso. -->
    <div class="cpa-aviso" *ngIf="!cargando && !errorCarga && !puedeEditar" role="note">
      <span class="material-icons" aria-hidden="true">lock</span>
      <span class="cpa-aviso-txt">
        <b>Sólo lectura.</b> Esta bandeja es del perfil «Edicion Matriz de Riesgos IA», que revisa,
        acepta o descarta los cambios propuestos.
        <ng-container *ngIf="pendientes.length > 0">
          Hoy esperan <span class="cpa-num">{{ pendientes.length }}</span>.
        </ng-container>
      </span>
    </div>

    <!-- Con un error de carga tampoco: debajo del aviso rojo, «No hay cambios
         esperando aprobación» contradecía que no se pudo consultar. -->
    <section class="table-page__card" *ngIf="cargando || (puedeEditar && !errorCarga)">
      <div class="table-page__toolbar table-page__toolbar--filters cpa-barra">
        <div class="cpa-vistas" role="tablist" aria-label="Qué propuestas ver">
          <button type="button" role="tab" class="cpa-vista" [class.is-activa]="vista === 'PENDIENTES'"
                  [attr.aria-selected]="vista === 'PENDIENTES'" (click)="cambiaVista('PENDIENTES')">
            Por aprobar <span class="cpa-n">{{ pendientes.length }}</span>
          </button>
          <button type="button" role="tab" class="cpa-vista" [class.is-activa]="vista === 'RESUELTAS'"
                  [attr.aria-selected]="vista === 'RESUELTAS'" (click)="cambiaVista('RESUELTAS')">
            Ya resueltas <span class="cpa-n">{{ resueltos.length }}</span>
          </button>
        </div>

        <div class="table-page__filters-grid cpa-filtros">
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Buscar</mat-label>
              <input matInput aria-label="Buscar" name="busca" [(ngModel)]="busca" (ngModelChange)="armaFilas()" maxlength="60"
                     placeholder="Folio, nombre, SIA o quién la propuso" />
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium" *ngIf="matrices.length > 1 || filtroMatriz">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Matriz</mat-label>
              <mat-select name="matriz" [(ngModel)]="filtroMatriz" (selectionChange)="armaFilas()">
                <mat-option [value]="null">Todas</mat-option>
                <mat-option *ngFor="let m of matrices" [value]="m.idMatriz">{{ m.nombre }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  *ngIf="hayFiltro" (click)="limpiarFiltros()">
            <span class="material-icons" aria-hidden="true">filter_alt_off</span>
            Limpiar
          </button>
          <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="cargar()"
                  [disabled]="cargando">
            <span class="material-icons" aria-hidden="true">refresh</span>
            Actualizar
          </button>
        </div>
      </div>

      <div class="table-page__table-wrap" *ngIf="filas.length > 0; else cpaVacio">
        <table class="table-page__table cpa-tabla">
          <thead>
            <tr>
              <th>Qué se propone</th>
              <th>Registro</th>
              <th>Resumen</th>
              <th>Propuso</th>
              <th *ngIf="vista === 'RESUELTAS'">Resolución</th>
              <th class="table-page__actions-head">Revisar</th>
            </tr>
          </thead>
          <tbody>
            <!-- El Enter de la fila sólo actúa con la fila enfocada y devuelve null, no false:
                 con false Angular cancelaría el Enter del botón Revisar. -->
            <tr *ngFor="let p of filas; trackBy: trackPendiente" class="is-clickable" (click)="abrir(p)"
                (keydown.enter)="$event.target === $event.currentTarget ? abrir(p) : null">
              <td>
                <div class="table-page__cell-stack">
                  <span [class]="claseOperacion(p)">{{ operacionTexto(p) }}</span>
                  <span class="cpa-que">{{ entidadTexto(p) }}</span>
                </div>
              </td>
              <td>
                <div class="table-page__cell-stack">
                  <span class="cpa-sia" *ngIf="p.solicitudFolio && p.operacion === 'ALTA'">
                    <span class="material-icons" aria-hidden="true">assignment_turned_in</span>
                    Alta desde {{ p.solicitudFolio }}
                  </span>
                  <strong class="cpa-registro">{{ registroTexto(p) }}</strong>
                  <span class="cpa-sub" *ngIf="esNuevo(p) && p.estatus === 'PENDIENTE'">Nuevo: el folio nace al aceptarlo</span>
                  <span class="cpa-sub cpa-sub--ok" *ngIf="nacio(p)">Nació {{ nacio(p) }}</span>
                  <span class="cpa-sub" *ngIf="p.matrizNombre && matrices.length > 1">{{ p.matrizNombre }}</span>
                </div>
              </td>
              <td><span class="cpa-sumario">{{ p.resumen }}</span></td>
              <td>
                <div class="table-page__cell-stack">
                  <span class="cpa-quien">{{ nombre(p.proponeNombre) }}</span>
                  <span class="cpa-sub cpa-num">{{ p.fechaPropuesta | fechaBitacora }}</span>
                </div>
              </td>
              <td *ngIf="vista === 'RESUELTAS'">
                <div class="table-page__cell-stack">
                  <span [class]="claseEstatus(p)">{{ estatusTexto(p) }}</span>
                  <span class="cpa-sub">
                    {{ nombre(p.resuelveNombre) }} · <span class="cpa-num">{{ p.fechaResolucion | fechaBitacora }}</span>
                  </span>
                  <span class="cpa-motivo" *ngIf="p.motivo">«{{ p.motivo }}»</span>
                </div>
              </td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn"
                        [title]="p.estatus === 'PENDIENTE' && puedeEditar ? 'Revisar y decidir' : 'Ver'"
                        [attr.aria-label]="'Revisar: ' + titulo(p) + ', ' + registroTexto(p)"
                        (click)="$event.stopPropagation(); abrir(p)">
                  <span class="material-icons" aria-hidden="true">
                    {{ p.estatus === 'PENDIENTE' && puedeEditar ? 'fact_check' : 'visibility' }}
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-page__footer" *ngIf="filas.length > 0">
        <span class="table-page__meta cpa-meta">
          <span class="cpa-num">{{ filas.length }}</span>
          {{ vista === 'PENDIENTES'
              ? (filas.length === 1 ? 'propuesta espera aprobación' : 'propuestas esperan aprobación')
              : (filas.length === 1 ? 'propuesta resuelta (de las últimas 50)' : 'propuestas resueltas (de las últimas 50)') }}
          <ng-container *ngIf="filtroMatriz && nombreMatrizFiltro"> · {{ nombreMatrizFiltro }}</ng-container>
        </span>
        <span class="cpa-meta" *ngIf="vista === 'PENDIENTES'">De la más vieja a la más nueva</span>
      </div>

      <ng-template #cpaVacio>
        <div class="table-page__empty" *ngIf="!cargando; else cpaCargando">
          <span class="material-icons" aria-hidden="true">{{ vista === 'PENDIENTES' ? 'task_alt' : 'history' }}</span>
          <h3 class="cpa-vacio-tit">
            {{ hayFiltro ? 'Nada con esos filtros'
               : (vista === 'PENDIENTES' ? 'No hay cambios esperando aprobación' : 'Todavía no se ha resuelto ninguna propuesta') }}
          </h3>
          <p class="cpa-vacio-txt">
            {{ hayFiltro ? 'Quita la búsqueda o elige «Todas» en Matriz.'
               : (vista === 'PENDIENTES'
                   ? 'Cuando alguien guarde algo en la matriz con el control de cambios encendido, aparecerá aquí para aceptarlo o descartarlo.'
                   : 'Aquí se ven las aceptadas y las descartadas, con quién las resolvió y el motivo.') }}
          </p>
        </div>
      </ng-template>

      <ng-template #cpaCargando>
        <div class="table-page__empty table-page__empty--loading">
          <span class="material-icons" aria-hidden="true">hourglass_top</span>
          <h3 class="cpa-vacio-tit">Consultando propuestas</h3>
          <p class="cpa-vacio-txt">Espera un momento.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>

<!-- ==================== DETALLE (base admin/ajustes) ==================== -->
<div class="main-content ajustes-page cpa cpa-det" *ngIf="abierta as p">
  <div class="container-fluid">
    <section class="ajustes-hero">
      <div class="ajustes-hero__identity">
        <div [class]="'cpa-det-ico cpa-det-ico--' + tono(p)" aria-hidden="true">
          <span class="material-icons">
            {{ p.entidad === 'RIESGO' ? 'policy' : (p.entidad === 'ACTIVO' ? 'inventory_2' : 'event_note') }}
          </span>
        </div>
        <div class="ajustes-hero__content">
          <h1>{{ titulo(p) }}</h1>
          <p class="ajustes-hero__role">{{ registroTexto(p) }}</p>
          <div class="ajustes-hero__meta">
            <span class="cpa-est" [class.cpa-est--pend]="p.estatus === 'PENDIENTE'"
                  [class.cpa-est--apl]="p.estatus === 'APLICADO'"
                  [class.cpa-est--desc]="p.estatus === 'DESCARTADO'">{{ estatusTexto(p) }}</span>
            <span class="ajustes-hero__meta-text" *ngIf="p.matrizNombre">{{ p.matrizNombre }}</span>
            <span class="ajustes-hero__meta-text">
              Propuso {{ nombre(p.proponeNombre) }} · <span class="cpa-num">{{ p.fechaPropuesta | fechaBitacora }}</span>
            </span>
          </div>
        </div>
      </div>
      <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact cpa-volver"
              (click)="volverALista()">
        <span class="material-icons" aria-hidden="true">arrow_back</span>
        Volver a la lista
      </button>
    </section>

    <div class="row ajustes-layout">
      <!-- ===== Qué cambia ===== -->
      <div class="col-12 col-xl-8">
        <section class="ajustes-card">
          <div class="ajustes-card__header">
            <div class="ajustes-card__title">
              <i class="material-icons" aria-hidden="true">compare_arrows</i>
              <span>Qué cambia</span>
            </div>
            <button type="button" class="cpa-filtro" *ngIf="comparacion" (click)="alternarSoloCambios()">
              {{ soloCambios ? 'Ver también lo que no cambia' : 'Ver sólo lo que cambia' }}
            </button>
          </div>

          <div class="ajustes-card__body">
            <p class="cpa-texto" *ngIf="p.estatus !== 'PENDIENTE'">
              Esta propuesta ya se resolvió: la comparación sólo se arma para las que esperan
              aprobación. Lo que se propuso: <b>{{ p.resumen }}</b>.
            </p>
            <p class="cpa-texto" *ngIf="p.estatus === 'PENDIENTE' && !puedeEditar">
              El detalle de lo que cambia sólo lo ve el perfil «Edicion Matriz de Riesgos IA».
              Lo que se propone: <b>{{ p.resumen }}</b>.
            </p>

            <p class="cpa-texto" *ngIf="comparando" role="status">Comparando con la matriz de hoy…</p>

            <div class="cpa-aviso cpa-aviso--error" *ngIf="errorDetalle" role="alert">
              <span class="material-icons" aria-hidden="true">error_outline</span>
              <span class="cpa-aviso-txt">{{ errorDetalle }}</span>
            </div>

            <div class="cpa-cmp" *ngIf="comparacion as c">
              <div class="cpa-marcador">
                <span class="cpa-tot cpa-tot--alta" *ngIf="c.agregados">
                  <span class="cpa-num">{{ c.agregados }}</span> {{ c.agregados === 1 ? 'se agrega' : 'se agregan' }}
                </span>
                <span class="cpa-tot cpa-tot--baja" *ngIf="c.eliminados">
                  <span class="cpa-num">{{ c.eliminados }}</span> {{ c.eliminados === 1 ? 'se quita' : 'se quitan' }}
                </span>
                <span class="cpa-tot cpa-tot--cambio" *ngIf="c.cambiados">
                  <span class="cpa-num">{{ c.cambiados }}</span>
                  {{ c.cambiados === 1 ? 'campo cambia' : 'campos cambian' }}
                </span>
                <span class="cpa-tot" *ngIf="c.sinCambios">
                  Sin diferencias con la matriz de hoy: aceptarla no cambiaría nada
                </span>
              </div>

              <div class="cpa-cols" aria-hidden="true">
                <span>Campo</span>
                <span>{{ c.etiquetaAntes }}</span>
                <span>{{ c.etiquetaDespues }}</span>
              </div>

              <div class="cpa-grupo" *ngFor="let v of vistaGrupos" [ngClass]="'cpa-n' + (v.grupo.nivel || 0)">
                <div class="cpa-grupo-cab">
                  <span [class]="claseEstado(v.grupo.estado)">{{ etiquetaEstado(v.grupo.estado) }}</span>
                  <strong class="cpa-grupo-tit">{{ v.grupo.titulo }}</strong>
                  <span class="cpa-ctx" *ngIf="v.grupo.contexto">{{ v.grupo.contexto }}</span>
                </div>
                <div [class]="claseFila(r.estado)" *ngFor="let r of v.renglones">
                  <span class="cpa-campo">{{ r.etiqueta }}</span>
                  <span class="cpa-hoy">
                    <span class="cpa-lado">{{ c.etiquetaAntes }}</span>
                    <span [class.cpa-vacio]="!r.antes">{{ r.antes || '—' }}</span>
                  </span>
                  <span class="cpa-prop">
                    <span class="cpa-lado">{{ c.etiquetaDespues }}</span>
                    <span [class.cpa-vacio]="!r.despues">{{ r.despues || '—' }}</span>
                  </span>
                </div>
                <p class="cpa-texto cpa-nada" *ngIf="v.renglones.length === 0">Sin cambios en este bloque.</p>
              </div>

              <p class="cpa-texto cpa-pie" *ngIf="ocultos > 0 && soloCambios">
                Se ocultaron <span class="cpa-num">{{ ocultos }}</span>
                {{ ocultos === 1 ? 'bloque que no cambia' : 'bloques que no cambian' }}.
              </p>
              <p class="cpa-texto cpa-pie">
                El riesgo, la clasificación y la periodicidad no se muestran: se recalculan solos al aplicarla.
              </p>
            </div>
          </div>
        </section>
      </div>

      <!-- ===== Decisión y datos ===== -->
      <div class="col-12 col-xl-4">
        <section class="ajustes-card cpa-decision">
          <div class="ajustes-card__header">
            <div class="ajustes-card__title">
              <i class="material-icons" aria-hidden="true">gavel</i>
              <span>Decisión</span>
            </div>
          </div>
          <div class="ajustes-card__body">
            <ng-container *ngIf="p.estatus === 'PENDIENTE'; else cpaResuelta">
              <ng-container *ngIf="puedeEditar; else cpaSoloLectura">
                <p class="cpa-texto">{{ queAlAceptar }}</p>
                <p class="cpa-texto">{{ notaBitacora }}</p>

                <div class="cpa-acciones" *ngIf="!descartando">
                  <!-- Si el detalle no se pudo armar (el registro ya no existe, la carga no
                       se lee...), aceptar fallaría: sólo queda descartarla. -->
                  <button type="button" class="app-form-btn app-form-btn--primary" (click)="aceptar()"
                          [disabled]="enviando || !!errorDetalle">
                    {{ enviando ? 'Aplicando…' : 'Aceptar y aplicar' }}
                  </button>
                  <button type="button" class="app-form-btn app-form-btn--secondary" (click)="empezarDescarte()"
                          [disabled]="enviando">
                    Descartar
                  </button>
                </div>

                <div class="cpa-descarte" *ngIf="descartando">
                  <label for="cpa-motivo" class="cpa-etq">
                    ¿Por qué se descarta? <span class="cpa-oblig" aria-hidden="true">*</span>
                  </label>
                  <textarea id="cpa-motivo" class="cpa-motivo-in" rows="4" name="motivo" required
                            [maxlength]="maxMotivo" [(ngModel)]="motivo"
                            placeholder="Quien lo propuso lo va a leer."></textarea>
                  <span class="cpa-cuenta cpa-num">{{ motivo.length }}/{{ maxMotivo }}</span>
                  <div class="cpa-acciones">
                    <button type="button" class="app-form-btn app-form-btn--danger" (click)="descartar()"
                            [disabled]="enviando || !motivo.trim()">
                      {{ enviando ? 'Descartando…' : 'Descartar la propuesta' }}
                    </button>
                    <button type="button" class="app-form-btn app-form-btn--secondary" (click)="cancelarDescarte()"
                            [disabled]="enviando">
                      Cancelar
                    </button>
                  </div>
                </div>
              </ng-container>
              <ng-template #cpaSoloLectura>
                <p class="cpa-texto">
                  Sólo lectura: aceptar o descartar es del perfil «Edicion Matriz de Riesgos IA».
                </p>
              </ng-template>
            </ng-container>

            <ng-template #cpaResuelta>
              <p class="cpa-texto" *ngIf="p.estatus === 'APLICADO'">
                <b>Se aplicó</b> · {{ nombre(p.resuelveNombre) }} ·
                <span class="cpa-num">{{ p.fechaResolucion | fechaBitacora }}</span>.
                <ng-container *ngIf="nacio(p)"> Nació <b>{{ nacio(p) }}</b>.</ng-container>
              </p>
              <ng-container *ngIf="p.estatus === 'DESCARTADO'">
                <p class="cpa-texto">
                  <b>Se descartó</b> · {{ nombre(p.resuelveNombre) }} ·
                  <span class="cpa-num">{{ p.fechaResolucion | fechaBitacora }}</span>. La matriz no cambió.
                </p>
                <p class="cpa-texto cpa-motivo" *ngIf="p.motivo">«{{ p.motivo }}»</p>
              </ng-container>
            </ng-template>
          </div>
        </section>

        <section class="ajustes-card">
          <div class="ajustes-card__header">
            <div class="ajustes-card__title">
              <i class="material-icons" aria-hidden="true">description</i>
              <span>La propuesta</span>
            </div>
          </div>
          <div class="ajustes-card__body cpa-datos">
            <div class="ajustes-data-item">
              <span class="ajustes-data-item__label">Resumen</span>
              <strong>{{ p.resumen }}</strong>
            </div>
            <div class="ajustes-data-item">
              <span class="ajustes-data-item__label">De qué es</span>
              <strong>{{ entidadTexto(p) }}</strong>
            </div>
            <div class="ajustes-data-item" *ngIf="p.solicitudFolio && p.operacion === 'ALTA'">
              <span class="ajustes-data-item__label">Viene de</span>
              <strong>La solicitud {{ p.solicitudFolio }}, al autorizarse</strong>
            </div>
            <div class="ajustes-data-item">
              <span class="ajustes-data-item__label">Propuso</span>
              <strong>{{ nombre(p.proponeNombre) }}</strong>
            </div>
            <div class="ajustes-data-item">
              <span class="ajustes-data-item__label">Cuándo</span>
              <strong class="cpa-num">{{ p.fechaPropuesta | fechaBitacora }}</strong>
            </div>
            <div class="ajustes-data-item" *ngIf="p.matrizNombre">
              <span class="ajustes-data-item__label">Matriz</span>
              <strong>{{ p.matrizNombre }}</strong>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
